import { useTranslation } from 'gatsby-plugin-react-i18next'
import React from 'react'
import { isAndroid, isIOS } from 'react-device-detect'

import Icon from '../../../images/burger-taco-friends.svg'
import CloseArrow from '../../../images/close.svg'

type Props = {
  onClose: () => void
}

const OneDollarLunchPromo: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()

  const getFormattedMessage = () => {
    if (isAndroid) {
      return 'sms://+18449374362/?body=credit'
    } else if (isIOS) {
      return 'sms://+18449374362/&body=credit'
    } else {
      return 'sms://+18449374362/?body=credit'
    }
  }

  return (
    <>
      <button className="modal__close" onClick={onClose}>
        <img src={CloseArrow} />
      </button>
      <div className="modal__one_dollar__title">{t('Congratulations!')}</div>
      <div className="modal__content">
        <img src={Icon} className="modal__one_dollar__icon" />
        <div className="modal__one_dollar__subtitle">
          {t("You've got a ")}
          <div className="modal__one_dollar__subtitle__bold">{t('$20 MealPal credit!')}</div>
        </div>

        <a href={getFormattedMessage()} className="modal__one_dollar__action red-cta" onClick={onClose}>
          {t('TEXT ME $20 CREDIT')}
        </a>
      </div>
      <div className="modal__one_dollar__description">
        {t('Click the button above to text us and get the $20 credit, or text "credit" to')} <br />
        {t('844-937-4362')}
      </div>
    </>
  )
}

export default OneDollarLunchPromo
